import React from "react";
import styled from "styled-components";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";
import { darkTheme } from "@themes/Theme";

const Pill = styled.div<{ color: PillColor }>`
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${(props) => getColorForVariant(props.color)};
    height: 15px;
    width: fit-content;
    padding: 1px 7px;

    border-radius: 8px;
    font-size: ${FontSize.mini};
    color: ${darkTheme.textColorPrimary};
`;

type PillColor = "purple" | "black";

interface PillIndicatorProps {
    readonly label: string;
    readonly color?: PillColor;
    readonly className?: string;
}
export default function PillIndicator(props: PillIndicatorProps) {
    return (
        <Pill className={props.className} color={props.color}>
            {props.label}
        </Pill>
    );
}

const getColorForVariant = (variant: PillColor) => {
    switch (variant) {
        case "black":
            return darkTheme.backgroundPrimary;
        default:
            return Styles.lifeatSpecialPurple;
    }
};
